import React from "react";
import TicketListing from "./TicketListing";

const TicketListingWrapper = ({
  // Core data
  tickets,
  userInfoData,

  // Loading states
  isLoading,

  // Event handlers
  onTicketClick,
  onTicketAction,
  onVerifyClick,
  onMarkAsResolved,
  onReopenTicket,

  // Filter states
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  priorityFilter,
  setPriorityFilter,
  startDate,
  endDate,
  onDateChange,
  issueTypeFilter,
  setIssueTypeFilter,
  raisedByFilter,
  setRaisedByFilter,
  supervisorFilter,
  setSupervisorFilter,
  gymFilter,
  setGymFilter,

  // Filter options
  issueTypeOptions,
  raisedByOptions,
  supervisorOptions,

  // Pagination
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  tablePagination,

  // Additional handlers
  onResetFilters,

  // Manager assignment specific props (optional)
  isManagerAssignment = false,
  managerSupervisors = [],
  managerSupervisorsLoading = false,
  selectedAssignments = {},
  setSelectedAssignments,
  assigningTickets = {},
  onAssignTicket,

  // Status filter visibility control
  hideStatusFilter = false,
  showAssignButton = false,

  // Any additional props that might be needed
  handleReload,
  ...additionalProps
}) => {
  return (
    <TicketListing
      tickets={tickets}
      onTicketClick={onTicketClick}
      onVerifyClick={onVerifyClick}
      onMarkAsResolved={onMarkAsResolved}
      onReopenTicket={onReopenTicket}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      priorityFilter={priorityFilter}
      setPriorityFilter={setPriorityFilter}
      startDate={startDate}
      endDate={endDate}
      onDateChange={onDateChange}
      isPage={isPage}
      setIsPage={setIsPage}
      pageLimit={pageLimit}
      setPageLimit={setPageLimit}
      tablePagination={tablePagination}
      userInfoData={userInfoData}
      // New filter props
      issueTypeFilter={issueTypeFilter}
      setIssueTypeFilter={setIssueTypeFilter}
      raisedByFilter={raisedByFilter}
      setRaisedByFilter={setRaisedByFilter}
      supervisorFilter={supervisorFilter}
      setSupervisorFilter={setSupervisorFilter}
      gymFilter={gymFilter}
      setGymFilter={setGymFilter}
      issueTypeOptions={issueTypeOptions}
      raisedByOptions={raisedByOptions}
      supervisorOptions={supervisorOptions}
      onResetFilters={onResetFilters}
      // Manager assignment specific props
      isManagerAssignment={isManagerAssignment}
      managerSupervisors={managerSupervisors}
      managerSupervisorsLoading={managerSupervisorsLoading}
      selectedAssignments={selectedAssignments}
      setSelectedAssignments={setSelectedAssignments}
      assigningTickets={assigningTickets}
      onAssignTicket={onAssignTicket}
      // Status filter visibility
      hideStatusFilter={hideStatusFilter}
      showAssignButton={showAssignButton}
      // Spread any additional props
      handleReload={handleReload}
      {...additionalProps}
    />
  );
};

export default TicketListingWrapper;
